"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsAudioInput = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _JoinComponent = require("../JoinComponent.styled");
var _utils = require("../utils");
var _useCommonPageActionsApi = require("@studio/metrics/client/react/useCommonPageActionsApi");
var _useAudioVideoDevice = require("@studio/chime/hooks/useAudioVideoDevice");
var _DeviceTypes = require("@studio/constants/DeviceTypes");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SettingsAudioInput = exports.SettingsAudioInput = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var _formattedAudioInputD;
  var meetingSession = _ref.meetingSession,
    selectedAudioInputId = _ref.selectedAudioInputId,
    onAudioInputChange = _ref.onAudioInputChange,
    isDisabled = _ref.isDisabled;
  // Preserves original selectedAudioInputId in case of disconnect
  // This id will then be used to reconnect if device becomes available
  var _useState = (0, _react.useState)(selectedAudioInputId),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    originalDeviceId = _useState2[0],
    setOriginalDeviceId = _useState2[1];
  var _useCommonPageActions = (0, _useCommonPageActionsApi.useCommonPageActionsApi)(),
    microphoneChanged = _useCommonPageActions.microphoneChanged;
  var handleManualChange = function handleManualChange(deviceId, audioInputName) {
    setOriginalDeviceId(deviceId);
    onAudioInputChange(deviceId);
    microphoneChanged({
      microphoneName: audioInputName
    });
  };
  var _useState3 = (0, _react.useState)([]),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    audioInputDevices = _useState4[0],
    setAudioInputDevices = _useState4[1];
  (0, _useAudioVideoDevice.useAudioVideoDevice)({
    meetingSession: meetingSession,
    setDevices: setAudioInputDevices,
    onDeviceChanged: onAudioInputChange,
    selectedDeviceId: selectedAudioInputId,
    deviceType: _DeviceTypes.AUDIO_INPUT
  });
  var formattedAudioInputDevices = (0, _utils.formatDevicesArrayForDropdown)(audioInputDevices);

  // A bluetooth device and fallback device can both have 'default' as deviceId
  // groupId is used to distinguish between them by specifying when the hardware has changed.
  // This check ensures the useEffect triggers and updates which device is being used.
  var selectedGroupId = formattedAudioInputDevices === null || formattedAudioInputDevices === void 0 || (_formattedAudioInputD = formattedAudioInputDevices.find(function (device) {
    return device.value === selectedAudioInputId;
  })) === null || _formattedAudioInputD === void 0 ? void 0 : _formattedAudioInputD.group;

  // Handles fallback to default when bluetooth device disconnects PROD-215932
  (0, _react.useEffect)(function () {
    if (!originalDeviceId || !onAudioInputChange) return;
    var deviceConnected = formattedAudioInputDevices.find(function (option) {
      return option.value === originalDeviceId;
    });
    if (!deviceConnected) {
      var _formattedAudioInputD2;
      onAudioInputChange((_formattedAudioInputD2 = formattedAudioInputDevices[0]) === null || _formattedAudioInputD2 === void 0 ? void 0 : _formattedAudioInputD2.value);
    } else {
      onAudioInputChange(originalDeviceId);
    }
  }, [onAudioInputChange, originalDeviceId, audioInputDevices]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledFormDropdown, {
    labelText: "Select and test microphone",
    "data-testid": "selectMicrophone",
    selected: selectedAudioInputId,
    options: formattedAudioInputDevices,
    id: "selectMicrophone",
    onChange: handleManualChange,
    disabled: isDisabled
  }), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledMicrophoneVolumeBar, {
    selectedAudioInputId: selectedAudioInputId,
    selectedGroupId: selectedGroupId,
    disabled: isDisabled
  }));
});